import {
  ALL_ARRANGEMENTS_FILTER_VALUE,
  arrangementApiService,
} from 'api/arrangements/arrangement.api.service';
import { ArrangementPreview } from 'api/arrangements/types';
import { AsyncThunk } from '@reduxjs/toolkit/src/createAsyncThunk';
import { FulfillmentOptionType } from 'types/cart.types';
import { SortParams } from 'types/arrangement-service.types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { parseAxiosError } from 'utils/errors';
import { readBoolHeader } from 'utils/read-axios-header';
import { searchArrangementApiService } from 'api/search-arrangement.api.service';
import axios from 'axios';

export type Params = {
  filterIds?: (string | number)[];
  orderType?: FulfillmentOptionType;
  dyid?: string;
  dyid_server?: string;
  search?: string;
  areaId?: number;
  storeId?: number;
  date?: Date;
  sort?: SortParams;
  limit?: number;
  fruitFilterValue?: string;
  isGiftFinder?: boolean;
  isOneHourDelivery?: boolean;
  newCMS?: boolean;
};

export enum AbortReason {
  NewSearch = 'new_search',
}

const ABORTED = 'aborted';

type ArrangementsPayload = {
  arrangements: ArrangementPreview[];
  plpOptimized: boolean | null;
};

export const createGetArrangementsAction = (
  typePrefix: string,
): AsyncThunk<ArrangementsPayload, Params, Record<string, never>> =>
  createAsyncThunk(typePrefix, async (params: Params, thunkAPI) => {
    const source = axios.CancelToken.source();
    const url = window.location.href;
    const matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
    const paramCount = matches ? matches.length : 0;

    thunkAPI.signal.addEventListener('abort', () => {
      source.cancel(ABORTED);
    });

    try {
      if (params.search && params.search !== '') {
        const results = await searchArrangementApiService.getSearch(
          params.search,
        );
        return { arrangements: results, plpOptimized: null };
      }

      const { ...filteredParams } = params;
      const res = await arrangementApiService.find(
        {
          ...filteredParams,
          filterIds: filteredParams.filterIds
            ? filteredParams.filterIds.join(',')
            : ALL_ARRANGEMENTS_FILTER_VALUE,
        },
        { cancelToken: source.token },
      );

      const plpOptimized = readBoolHeader(res, 'x-plp-optimized');

      if (
        res.data &&
        res.data.length <= 0 &&
        paramCount === 1 &&
        params.search &&
        params.search !== ''
      ) {
        const results = await searchArrangementApiService.getSearch(
          params.search,
        );
        return { arrangements: results, plpOptimized: null };
      }

      return { arrangements: res.data, plpOptimized };
    } catch (e) {
      return thunkAPI.rejectWithValue(
        Object.hasOwnProperty.call(e, 'message') &&
          (e as { message: unknown }).message === ABORTED
          ? { message: ABORTED }
          : parseAxiosError(e),
      );
    }
  });

export const fetchArrangements = createGetArrangementsAction(
  'plp/arrangements/fetch',
);
